import React, { useState, useEffect } from 'react';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, Input, Label } from "reactstrap";
import DefaultProfileImage from '../../Components/Common/DefaultProfileImage';
// const avatar1 = '';
import { getOwnPersonalInfoSuccess } from '../../slices/auth/settings/reducer';
/**
 * UserInfo component representing the user information display card.
 * This component displays the user's profile picture, name, and role in a card format.
 * @component
 */
function UserInfo() {
  const dispatch = useDispatch();
  const selectStates = createSelector(state => state, state => ({
    user: state.Login.user,
    personalInfo: state.Settings.personalInfo
  }));
  const {user, personalInfo} = useSelector(selectStates);
  const [previewPicture, setPreviewPicture] = useState(false);

  async function handlePictureChange(e) {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = async (event) => {
      dispatch(getOwnPersonalInfoSuccess({...personalInfo, picture: e.target.files[0]}));
      setPreviewPicture(event.target.result);
    }
    reader.readAsDataURL(file);
  }

  return (
    <Card>
      <CardBody className="p-4">
        <div className="text-center">
          <div className="profile-user position-relative d-inline-block mx-auto mb-3">
            {personalInfo?.hasOwnProperty('picture') && personalInfo.picture ?
              <img src={previewPicture ? previewPicture : personalInfo?.picture}
                className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                alt="user-profile"
                draggable="false"
              />
              :  
                <DefaultProfileImage avatar='avatar-xl' fontSize='1' firstName={user.data.firstName} lastName={user.data.lastName} /> 
              } 
            <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
              <Input id="profile-img-file-input" type="file"
                className="profile-img-file-input" onChange={handlePictureChange} />
              <Label htmlFor="profile-img-file-input"
                className="profile-photo-edit avatar-xs">
                <span className="avatar-title rounded-circle bg-light text-body">
                  <i className="ri-camera-fill"></i>
                </span>
              </Label>
            </div>
          </div>
          <h5 className="fs-16 mb-1">{(user?.data.firstName && user?.data.lastName ? user?.data.firstName + " " + user?.data.lastName : "")}</h5>
          <p className="text-muted mb-0">{(user?.data.role || "")}</p>
        </div>
      </CardBody>
    </Card>
  )
}

export default UserInfo;